import Notify from "vue-notifyjs";
import SideBar from "@/components/SidebarPlugin";
import GlobalComponents from "./globalComponents";
import GlobalDirectives from "./globalDirectives";
import VueLoaders from "vue-loaders";
import PerfectScrollbar from "vue2-perfect-scrollbar";
import VueModalTor from "vue-modaltor/dist/vue-modaltor.common";
import "vue-modaltor/dist/vue-modaltor.css";
import "es6-promise/auto";
import Toasted from "vue-toasted";

//css assets
import "bootstrap/dist/css/bootstrap.css";
import "@/assets/sass/paper-dashboard.scss";
import "@/assets/css/themify-icons.css";
import "vue-loaders/dist/vue-loaders.css";
import "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css";

export default {
	install(Vue) {
		Vue.use(GlobalComponents);
		Vue.use(GlobalDirectives);
		Vue.use(SideBar);
		Vue.use(Notify);
		Vue.use(VueLoaders);
		Vue.use(PerfectScrollbar);
		Vue.use(VueModalTor, {
			bgPanel: "rgba(29, 27, 65, 1)",
			bgOverlay:
				"linear-gradient(to bottom left, #216e93, #21648a, #1f5881, #172d5b, #191c51)",
			closeScroll: true,
		});
		Vue.use(Toasted);
	},
};
